//
// Code originally taken from http://stackoverflow.com/a/36325468/48651
//
// Imports
import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

export interface IMngDynamicComponentData {
  component: any;
  inputs?: { [inputName: string]: any }; // to set component members
  providers?: { [providerName: string]: any }; // to be used by component Injector
  componentCreatedCallback?: (component: Component) => void;
  componentDestroyedCallback?: () => void;
}

//
// Dynamic component loader component
//
@Component({
  selector: 'mng-dynamic-component',
  templateUrl: './mng-dynamic.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class MngDynamicComponent implements OnChanges, OnInit, OnDestroy {
  // static counter = 0;

  // Private properties
  private componentReference: ComponentRef<any>;

  private isViewInitialized = false;

  // Component input
  @ViewChild('dynamicTarget', { read: ViewContainerRef, static: true })
  private dynamicTarget: ViewContainerRef;
  // private id: number;

  _componentData: IMngDynamicComponentData;

  @Input()
  set componentData(data: IMngDynamicComponentData) {
    this._componentData = data;
  }

  //
  // Called when the view changes
  //
  ngOnChanges(changes: SimpleChanges) {
    // this.log('ngOnChanges', changes);
    this.updateComponent();
  }

  ngOnInit() {
    // this.log('ngOnInit');
    this.isViewInitialized = true;
    this.updateComponent();
  }

  //
  // Called when we need to destroy the view
  //
  ngOnDestroy() {
    // this.log('ngOnDestroy');
    if (this.componentReference) {
      this.componentReference.destroy();
    }
  }

  //
  // Updates the view with the dynamically loaded component
  //
  private updateComponent() {
    // this.log('updateComponent');

    // console.log('updateComponent', this._componentData.component);
    if (!this.isViewInitialized) {
      // this.log('updateComponent --> !isViewInitialized --> return');
      return;
    }

    if (!this._componentData) {
      // this.log('updateComponent --> no componentData --> return');
      return;
    }

    // If we have a component, destroy it first
    if (this.componentReference) {
      // this.log('updateComponent --> componentReference exists --> destroy it...');
      this.componentReference.destroy();

      // Call the callback if needed
      if (this._componentData.componentDestroyedCallback) {
        this._componentData.componentDestroyedCallback();
      }
    }

    this._componentData.providers = this._componentData.providers || {};

    // Providers need to be in the following format to be resolved properly
    const componentProviders = Object.keys(this._componentData.providers).map((inputName) => {
      return { provide: inputName, useValue: this._componentData.providers[inputName] };
    });

    const options = { providers: componentProviders, parent: this.dynamicTarget.parentInjector };
    const injector = Injector.create(options);

    // this.log('updateComponent --> create Component...');
    // We create the component with the provided injector
    this.componentReference = this.dynamicTarget.createComponent(this._componentData.component, { injector });

    // this.componentReference.instance['title'] = 'XXYYY111';

    if (this._componentData.inputs) {
      Object.keys(this._componentData.inputs).forEach((key: string) => {
        this.componentReference.instance[key] = this._componentData.inputs[key];
      });
    }
    // If we need to, pass through the component we created
    if (this._componentData.componentCreatedCallback) {
      this._componentData.componentCreatedCallback(this.componentReference.instance);
    }
  }

  log(msg: string, value: any = ''): void {
    // console.log(`MngDynamicComponent - ID: ${this.id}`, msg, value);
  }
}
